<div class="modal-header">
  <h5 class="modal-title">{{ 'edit-subscription-notifications.no-changes-title' | translate }}</h5>
  <a href="javascript:;" (click)="activeModal.dismiss()" class="float-left ml-3">
    <i-feather name="x" class="text-white"></i-feather>
  </a>
</div>
<div class="modal-body">
  <div class="container-fluid">
    @if (currentlyReceiving) {
      <p>{{ 'edit-subscription-notifications.no-changes-text' | translate }}</p>
    } @else {
      <p>{{ 'edit-subscription-notifications.no-changes-text-not-receiving' | translate }}</p>
    }
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" (click)="activeModal.close()">
    {{ 'edit-subscription-notifications.close' | translate }}
  </button>
</div>
